// algorithm to get similarity between two strings
// https://es.wikipedia.org/wiki/Distancia_de_Levenshtein
export function levenshteinDistance(a, b) {
  const matrix = [];

  // Check if there is an empty string
  if (a.length === 0) return b.length;
  if (b.length === 0) return a.length;

  // Intialize the string matrix
  for (let i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  }
  for (let j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }

  // Fill the matrix with the comparison of strings
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1, // substitution
          matrix[i][j - 1] + 1, // insertion
          matrix[i - 1][j] + 1 // delete
        );
      }
    }
  }

  // return similarity
  return matrix[b.length][a.length];
}
